import { useState, useEffect, useContext } from 'react';

import FormContext from './Context';

export function useForm() {
  const value = useContext(FormContext);
  return value;
}

export function useWatch(name) {
  const { getValue, subscribeField } = useForm();
  const [value, setValue] = useState(getValue(name));

  useEffect(() => {
    const unsub = subscribeField(name, (newValue) => {
      setValue(newValue);
    });

    return unsub;
  }, [name]);

  return value;
}

export function useFormEffect(deps, callback) {
  const { registerEffect } = useForm();

  useEffect(() => {
    const unregister = registerEffect(deps, callback);

    return () => {
      unregister();
    };
  }, []);
}
